/* eslint-disable */
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { useTranslation } from "react-i18next";

import CardImage from '../../components/card-image'
import { TitleOne, TextBodyOne } from '../../components/text'
import OnDemandBody from '../../static/images/clean/background-service.svg'
import ic1 from '../../static/icons/service/clean/ic-1.svg'
import ic2 from '../../static/icons/service/clean/ic-2.svg'
import ic3 from '../../static/icons/service/clean/ic-3.svg'
import ic4 from '../../static/icons/service/clean/ic-4.svg'
import icCheck from '../../static/icons/ic-check.svg'
import { ListCleanStyle, DemandStyle } from './on-demand.styles'

const ListClean = ({ data = [] }) => {
  const { t } = useTranslation();

  return (
    <ListCleanStyle>
      <div className="title-service">{t('pageJasaCleaningService.part26')} :</div>
      <div className="list">
        {data.map((item, key) => (
          <div className="list-row" key={key}>
            <div className="check">
              <img className="check" src={icCheck} alt="halojasa/check" />
            </div>
            <span>{item.name}</span>
          </div>
        ))}
      </div>
    </ListCleanStyle>
  )
}

const OnDemand = () => {
  const { t } = useTranslation();

  return (
    <DemandStyle>
      <img src={OnDemandBody} alt="halojasa/halo-clean-body" />
      <Grid>
        <Row center="lg">
          <Col sm={12} xs={12} lg={8} className="column-bottom">
            <TitleOne display="block" align="center">
              {t('pageJasaCleaningService.part23')}
            </TitleOne>
            <div className="top-margin">
              <TextBodyOne display="block" align="center">
                {t('pageJasaCleaningService.part24')}
              </TextBodyOne>
            </div>
          </Col>
        </Row>
        <Row className="scroll-row">
          <Col
            className="scroll-col"
            sm={6}
            md={6}
            xs={6}
            lg={3}
            className="bottom-margin"
          >
            <CardImage
              noFluid
              titleTop={true}
              image={ic1}
              imageFix
              title={t('pageJasaCleaningService.part25')}
              desc={
                <ListClean
                  data={[
                    {
                      name: t('pageJasaCleaningService.part27')
                    },
                    {
                      name: t('pageJasaCleaningService.part28')
                    },
                    {
                      name: t('pageJasaCleaningService.part29')
                    },
                    {
                      name: t('pageJasaCleaningService.part30')
                    },
                    {
                      name: t('pageJasaCleaningService.part31')
                    }
                  ]}
                ></ListClean>
              }
            ></CardImage>
          </Col>
          <Col
            className="scroll-col"
            sm={6}
            md={6}
            xs={6}
            lg={3}
            className="bottom-margin"
          >
            <CardImage
              noFluid
              titleTop={true}
              imageFix
              image={ic2}
              title={t('pageJasaCleaningService.part32')}
              desc={
                <ListClean
                  data={[
                    {
                      name: t('pageJasaCleaningService.part33')
                    },
                    {
                      name: t('pageJasaCleaningService.part34')
                    },
                    {
                      name: t('pageJasaCleaningService.part35')
                    },
                    {
                      name: t('pageJasaCleaningService.part36')
                    }
                  ]}
                ></ListClean>
              }
            ></CardImage>
          </Col>
          <Col
            className="scroll-col"
            sm={6}
            md={6}
            xs={6}
            lg={3}
            className="bottom-margin"
          >
            <CardImage
              noFluid
              titleTop={true}
              image={ic3}
              imageFix
              title={t('pageJasaCleaningService.part37')}
              desc={
                <ListClean
                  data={[
                    {
                      name: t('pageJasaCleaningService.part38')
                    },
                    {
                      name: t('pageJasaCleaningService.part39')
                    },
                    {
                      name: t('pageJasaCleaningService.part40')
                    }
                  ]}
                ></ListClean>
              }
            ></CardImage>
          </Col>
          <Col
            className="scroll-col"
            sm={6}
            md={6}
            xs={6}
            lg={3}
            className="bottom-margin"
          >
            <CardImage
              noFluid
              titleTop={true}
              image={ic4}
              imageFix
              title={t('pageJasaCleaningService.part41')}
              desc={
                <ListClean
                  data={[
                    {
                      name: t('pageJasaCleaningService.part42')
                    },
                    {
                      name: t('pageJasaCleaningService.part43')
                    },
                    {
                      name: t('pageJasaCleaningService.part44')
                    },
                    {
                      name: t('pageJasaCleaningService.part45')
                    },
                    {
                      name: t('pageJasaCleaningService.part46')
                    }
                  ]}
                ></ListClean>
              }
            ></CardImage>
          </Col>
        </Row>
      </Grid>
    </DemandStyle>
  )
}

export default OnDemand
